const styles = () => ({
  root: {
    width: '100%',
    color: 'red',
    '& .MuiOutlinedInput-root': {
      height: '38px',
      borderRadius: '4px',
    },
  },
  box: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'start',
  },
  buttonActions: {
    textTransform: 'capitalize',
    height: '40px',
  },
  wrapperActions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '40px',
  },
  labelTypeSelector: {
    fontSize: '16px',
    color: 'black',
    letterSpacing: '.75px',
    textAlign: 'center',
    fontFamily: 'Barlow Condensed',
    textTransform: 'capitalize',
    fontWeight: 400,
  },
  descriptionText: {
    fontSize: '16px',
    color: 'black',
    letterSpacing: '.75px',
    textAlign: 'center',
    fontFamily: 'Barlow Condensed',
  },
  formDescription: {
    fontSize: '16px',
    color: 'black',
    letterSpacing: '.75px',
    textAlign: 'center',
    fontFamily: 'Barlow Condensed',
  },
  labelWithInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  wrapperField: {
    height: '86px',
  },
});

export default styles;
